import React from "react";
import DialogSearch from "../DialogSearch";
import TileVendor from "../../Tile/TileVendor";
import PropTypes from "prop-types";
import Vendor from "../../../Utility/Crud/Vendor";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchVendor extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for vendors by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered vendors.
     */
    getSearchResults(query) {
        return Vendor.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.vendorsIndexed);
        }
    }

    /**
     * @param {object} vendor The vendor object.
     * @returns A TileVendor component for this vendor.
     */
    renderTile(vendor) {
        return (
            <TileVendor
                key={vendor.id}
                vendor={vendor}
            />
        );
    }
}
